<div class="flow-sticky-content">
    <ng-content></ng-content>
</div>
